import { render, staticRenderFns } from "./sxqkhzlist.vue?vue&type=template&id=155aae3c&scoped=true"
import script from "./sxqkhzlist.vue?vue&type=script&lang=js"
export * from "./sxqkhzlist.vue?vue&type=script&lang=js"
import style0 from "./sxqkhzlist.vue?vue&type=style&index=0&id=155aae3c&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155aae3c",
  null
  
)

export default component.exports